import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import TableBase from 'components/Table/TableBase'
import styled from 'styled-components'
import { numberWithCommas } from 'utils'
import { Button } from 'antd'
import ModalDelete from 'components/Modal/ModalDelete'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { productService } from 'services'
import ModalUpdateProduct from './ModalUpdateProduct'

const OptionAction = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;

  svg {
    cursor: pointer;
  }
`

const HistoryTable = ({
  dataList,
  setParams,
}: {
  dataList: any
  setParams: (input: any) => void

}) => {
  const [isModalDelete, setIsModalDelete] = useState(false)
  const [productDeleteId, setProductDeleteId] = useState(0)
  const [isModalEdit, setIsModalEdit] = useState(false)
  const [productEditId, setProductEditId] = useState(0)
  const [loading, setLoading] = useState(false)

  const handleSubmitDelete = async () => {
    if (productDeleteId === 0) return
    setLoading(true)

    try {
      await productService.deleteProduct(
        productDeleteId,
        async (response) => {
          handleCloseModalDelete()
        },
        (response) => {
          toast.error(response?.message || 'Xóa dữ liệu không thành công')
          setLoading(false)
        }
      )
    } catch (error) {
      setLoading(false)
      console.error('deleteAddress', error)
    }
  }

  const handleShowModalDelete = (productId: any) => {
    setProductDeleteId(productId)
    setIsModalDelete(true)
  }
  const handleShowModalEdit = (productId: any) => {
    setProductEditId(productId)
    setIsModalEdit(true)
  }

  const handleCloseModalDelete = () => {
    setLoading(false)
    setIsModalDelete(false)
    setProductDeleteId(0)
    setParams(() => {
      const base: any = {
        page: 1,
        per_page: 10,
      }
      return base
    })

  }
  const handleCloseModalEdit = () => {
    setLoading(false)
    setIsModalEdit(false)
    setProductEditId(0)
    setParams(() => {
      const base: any = {
        page: 1,
        per_page: 10,
      }
      return base
    })

  }
  const columns = [

    {
      title: 'Sản phẩm',
      dataIndex: '',
      minWidth: 180,
      render: (_, record) => (
        <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center' }}>
          <div>
            <img src={record?.avatar} alt="" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 5 }} />
          </div>
          <div>
            <p style={{ color: '#999' }}>{record?.code}</p>
            <p>{record?.title}</p></div>
        </div>
      ),
    },
    {
      title: 'Khối lượng (Kg)',
      dataIndex: 'weight',
      minWidth: 150,
      render: (weight) => (weight || 0),
    },
    {
      title: 'Tiền hàng (VNĐ)',
      dataIndex: 'price',
      minWidth: 160,
      render: (price) => (price ? `${numberWithCommas(price)}` : 0),
    },
    {
      title: 'Khai giá hàng hóa (VNĐ)',
      dataIndex: 'product_price',
      minWidth: 180,
      render: (price) => (price ? `${numberWithCommas(price)}` : 0),
    },
    {
      title: 'Thao tác',
      dataIndex: '',
      width: 120,
      render: (_, record) => (
        <OptionAction>
          <Button onClick={() => handleShowModalEdit(record?.id)} icon={<EditOutlined />}>
          </Button>
          <Button onClick={() => handleShowModalDelete(record?.id)} icon={<DeleteOutlined />}>
          </Button>
        </OptionAction>
      ),
    },
  ]

  return (
    <>
      <TableBase
        columns={columns}
        dataSource={dataList?.data?.products}
        scroll={{ x: 900 }}
        rowKey={(row) => row.id}
        pagination={{
          current: dataList?.data?.meta?.current_page,
          pageSize: dataList?.data?.meta?.per_page,
          total: dataList?.data?.meta?.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            if (pageSize !== dataList?.data?.meta?.per_page) {
              page = 1
            }
            window.scrollTo({ top: 0, behavior: 'smooth' })
            setParams((prev) => ({
              ...prev,
              page: page,
              per_page: pageSize,
            }))
          },
          showTotal: (total) => `Tổng ${total}`,
        }}
      />
      <ModalDelete
        open={isModalDelete}
        onCancel={handleCloseModalDelete}
        onSubmit={handleSubmitDelete}
        loading={loading}
        title='Xóa sản phẩm'
      />
      <ModalUpdateProduct
        open={isModalEdit}
        productId={productEditId}
        onCancel={handleCloseModalEdit}

      />
    </>
  )
}

export default HistoryTable
